export default {
  setCurrentMedKeyTypeName(state, name) {
    state.currentMedKeyTypeName = name;
  }
};
